module.exports = __webpack_public_path__ + "img/lunasa prismriver.b37dc017.png";